module.exports = __webpack_public_path__ + "static/media/natural-stone-black.1edf3427.svg";